import React, { useEffect, useState } from 'react'
import DrivingSchoolInformationView from './components/DrivingSchoolInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const DrivingSchoolInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('driving-school-info', 'Pay for a Road Test', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <DrivingSchoolInformationView setIsError={setIsError} />
}

export default withTranslation('common')(DrivingSchoolInformation)
